import React, { Component } from "react";
import FormDataPremiCom from "../components/FormDataPremi_Com";
import SideBar from "../components/SideBar_Com";

class FormDataPremi extends Component {
    render() {
        return (
            <div className="home">
                <SideBar/>
                <div className="main">
                    <FormDataPremiCom/>
                </div>
            </div>
        );
    }
}

export default FormDataPremi;